<app-header-one [sticky]="true"></app-header-one>
<div class="pdf-container">
    <ng2-pdfjs-viewer #pdfViewerAutoLoad zoom="120"></ng2-pdfjs-viewer>
  </div>
<!-- <app-footer-one></app-footer-one> -->
<!-- your.component.html -->
<!-- <button (click)="openPdf();">Open Pdf</button> -->

<!-- <div style="width: 800px; height: 400px">
  <ng2-pdfjs-viewer 
    #pdfViewerOnDemand
    [externalWindow]="true"
    [downloadFileName]="'mytestfile.pdf'"
    [openFile]="false"
    [viewBookmark]="false"
    [download]="false"></ng2-pdfjs-viewer>
</div> -->
<!-- <div> -->
<!-- <div style="height: 600px">
  <ng2-pdfjs-viewer pdfSrc="gre_research_validity_data.pdf" viewerId="MyUniqueID" (onBeforePrint)="testBeforePrint()" (onAfterPrint)="testAfterPrint()" (onDocumentLoad)="testPagesLoaded($event)" (onPageChange)="testPageChange($event)">
  </ng2-pdfjs-viewer>
</div> -->